import { useAtomValue } from "jotai";
import { tenantAtom } from "../../atoms/GlobalAtoms";
import SidebarHeader from "./SidebarHeader";
import SidebarLinkFormatter from "./SidebarLinkFormatter";

interface Props {
  open: boolean;
  smallScreen: boolean;
  switcherOpen: boolean;
  requiresWorkspace: boolean;
  workspaceLoading: boolean;
  workspace: any;
  workspaceID: string;
  workspaceIds: string[];
  toggleOpen: () => void;
  links: {
    id: string | number;
    name?: string;
    type: string;
    css?: string;
    pageType?: string;
  }[];
  children: React.ReactNode;
}

const DesktopSidebar = ({
  open,
  smallScreen,
  switcherOpen,
  requiresWorkspace,
  workspaceLoading,
  workspace,
  workspaceID,
  workspaceIds,
  toggleOpen,
  links,
  children,
}: Props) => {
  const currentTenant = useAtomValue(tenantAtom);

  return (
    <>
      <aside
        className={`tw:flex tw:flex-col tw:h-screen tw:overflow-hidden tw:fixed tw:z-10 tw:bg-ultralight tw:shadow-[0_1px_8px_1px_rgba(0,0,0,0.15)]
          ${open ? "tw:w-[250px]" : "tw:w-[60px]"}
          `}
      >
        {!switcherOpen &&
        requiresWorkspace &&
        !workspaceLoading &&
        ((!workspaceID && !workspaceIds?.length) || workspaceID === "None") ? (
          <>
            <SidebarHeader toggleOpen={toggleOpen} open={open} />
            <div className="tw:p-3 tw:text-center">
              <small className="tw:font-medium">
                {workspaceIds?.length > 0
                  ? "Choose a workspace to get started."
                  : ""}
              </small>
            </div>
          </>
        ) : switcherOpen ? null : (
          <div
            className={`${
              currentTenant?.TenantName === "Mission Control"
                ? "tw:overflow-y-auto"
                : "tw:flex tw:flex-col tw:flex-1 tw:overflow-y-hidden"
            }`}
          >
            {links?.map((link, i) => {
              return (
                <SidebarLinkFormatter
                  key={i}
                  link={link as any}
                  workspace={workspace}
                  toggleOpen={toggleOpen}
                  open={open}
                />
              );
            })}
          </div>
        )}
      </aside>
      <main
        className={`tw:pt-[50px] tw:pb-[40px] tw:min-h-screen tw:relative ${
          open && !smallScreen ? "tw:ml-[250px]" : "tw:ml-[60px]"
        }`}
      >
        {children}
      </main>
    </>
  );
};

export default DesktopSidebar;
